<template>
    <page-layout
        :readonly="isBriefAccepted"
        :hide-footer="isBriefAccepted"
    >
        <template slot="header">
            <step-header
                :current-step="stepNumber"
                :total-steps="totalSteps"
                :title="pageTitle"
                :use-exit-modal="false"
                :is-loading="isLoading"
                :skip-steps="isBriefAccepted"
                :is-preview="isPreview"
            />
        </template>
        <template slot="default">
            <g-loader v-if="isLoading" type="fixed" />
            <div v-else>
                <g-typography tag="h4" :value="stepOverview" class="break-new-line" margins />
                <div v-if="assetsFiles" class="margin-bottom-normal">
                    <div v-for="file in assetsFiles" :key="file.id" class="margin-bottom-normal">
                        <float-on-mask tag="div" :float-up="isBriefAccepted">
                            <activations-brand-asset :asset="file" />
                        </float-on-mask>
                    </div>
                </div>
                <div v-else>
                    <g-typography tag="h4" margins>No assets available.</g-typography>
                </div>
            </div>
        </template>
        <template slot="footer">
            <step-footer
                v-if="isBriefEditable"
                :is-next-disabled="false"
                :step="step"
                :loading="isCompletingBrief"
                :use-exit-modal="false"
                :step-completed="isCompleted"
                :current-step="stepNumber"
                :total-steps="totalSteps"
                :is-preview="isPreview"
                @go-next-step="$emit('go-next-step', step)"
                @go-previous-step="$emit('go-previous-step', step)"
            />
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../layouts/PageLayout';
    import ActivationsBrandAsset from '../../library/ActivationsBrandAsset';
    import {get} from 'lodash';
    import StepHeader from './partials/StepHeader';
    import ActivationBriefMixin from './mixins/ActivationBriefMixin';
    import StepFooter from './partials/StepFooter';
    import {BRAND_ASSET_FILE_TYPE} from '../../../constants/activation-files';
    import {getActivationFiles} from '../../../helpers/activations/activation-files';
    import {getCustomizableText, getCustomizableTitle} from '../../../helpers/activations/default-texts';
    import FloatOnMask from '../../library/FloatOnMask';

    export default {
        name:       'ActivationBriefAssetsView',
        components: {
            StepFooter,
            StepHeader,
            ActivationsBrandAsset,
            PageLayout,
            FloatOnMask,
        },
        mixins: [
            ActivationBriefMixin,
        ],
        props: {
            brief: {
                type:    Object,
                default: null,
            },
            step: {
                type:    Object,
                default: null,
            },
            isLoading: {
                type:    Boolean,
                default: false,
            },
            isCompletingBrief: {
                type:    Boolean,
                default: false,
            },
        },
        computed: {
            pageTitle() {
                return getCustomizableTitle(this.brief, 'brand_assets_title');
            },
            stepOverview() {
                return getCustomizableText(this.brief, 'brand_assets_description');
            },
            stepNumber() {
                return get(this, 'step.meta.stepNumber', 0);
            },
            totalSteps() {
                return get(this, 'step.meta.totalSteps', 0);
            },

            isCompleted() {
                return get(this, 'step.is_complete', false);
            },
            assetsFiles() {
                return getActivationFiles(this.brief, BRAND_ASSET_FILE_TYPE);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-normal {
        margin-bottom: $g-spacing-5;
    }
    .margin-bottom-large {
        margin-bottom: $g-spacing-5;
    }

    .break-new-line {
        white-space: pre-line;
    }
</style>
